import create from 'zustand';
import { InvoiceStore, invoiceStoreDefinition } from '@ar/stores/InvoicesStore';

export type BillStore = InvoiceStore;

export const useBillStore = create<BillStore>(invoiceStoreDefinition);
